import WelcomePayOnShip from './WelcomePayOnShip';

export default WelcomePayOnShip;
